module.exports = __webpack_public_path__ + "img/img6.8344ab21.svg";